$(document).ready(function () {

    var $wrappers = $('.x-facebook-widget');

    if ($wrappers.length < 1)
        return;

    var $buttons = $('.js-fbsubmit-button', $wrappers);

    Vendd.User.AuthProviders.facebook.init();

    $buttons.click(function (e) {
        if (typeof (e.preventDefault) === 'function')
            e.preventDefault();
        Vendd.User.AuthProviders.facebook.login();
    });
});